import { FormGroup, FormControlLabel, Switch, FormHelperText } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../contexts/app_context/app_context";

/**
 * DefaultSwitchInput
 */

type Props = {
  name: string;
  activeLabel?: string;
  inactiveLabel?: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  readOnly?: boolean;
  helperText?: string;
  value?: boolean;
  onChange?: (newValue: boolean) => void;
};

export const DefaultSwitchInput = ({
  name,
  activeLabel = 'Ativo',
  inactiveLabel = 'Inativo',
  labelPlacement,
  readOnly,
  helperText,
  value,
  onChange,
}: Props) => {
  const { theme } = useContext(AppContext);
  return (
    <FormGroup>
      <FormControlLabel
        name={name}
        sx={{ color: theme === "dark" ? "white" : "black" }}
        label={value === true ? activeLabel : inactiveLabel}
        labelPlacement={labelPlacement}
        control={
          <Switch
            readOnly={readOnly}
            checked={value}
            onChange={(e) => { if (!readOnly) onChange?.(e.target.checked); }}
            sx={{
              color: "#009C4E",
              '& .MuiSwitch-switchBase': {
                '&.Mui-checked': {
                  color: '#009C4E',
                  '& + .MuiSwitch-track': {
                    backgroundColor: '#009C4E',
                  },
                },
              }
            }}
          />
        } />

      <FormHelperText id={`${name as string}-component-error-text`} error={true}>
        {helperText}
      </FormHelperText>
    </FormGroup>
  );
}